import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Paste the download link from a data-export email (Pro): three generic
 * steps, a URL field and Import. The parent starts the import and shows
 * progress or the error (docs/HISTORY_LINK_IMPORT_PLAN.md). Never names
 * the app the export comes from.
 */
export function ImportLinkForm({ busy, onImport }: Readonly<{
  busy: boolean;
  onImport: (url: string) => void;
}>) {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');
  const trimmed = url.trim();

  return (
    <form
      className="flex flex-col gap-2 rounded-xl border border-(--color-border) p-4 text-sm"
      onSubmit={(e) => {
        e.preventDefault();
        if (trimmed) onImport(trimmed);
      }}
    >
      <h3 className="font-semibold">{t('upload.link.title')}</h3>
      <ol className="list-decimal pl-5 text-(--color-text-secondary) flex flex-col gap-1">
        <li>{t('upload.link.step1')}</li>
        <li>{t('upload.link.step2')}</li>
        <li>{t('upload.link.step3')}</li>
      </ol>
      <label htmlFor="import-link" className="sr-only">{t('upload.link.label')}</label>
      <div className="flex gap-2">
        <input
          id="import-link"
          type="url"
          inputMode="url"
          autoComplete="off"
          spellCheck={false}
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder={t('upload.link.placeholder')}
          className="min-w-0 flex-1 rounded-lg bg-(--color-bg-tertiary) border border-(--color-border) px-3 py-2 text-(--color-text-primary) placeholder-(--color-text-secondary) text-sm focus:outline-none focus:ring-2 focus:ring-(--color-accent)/50"
        />
        <button
          type="submit"
          disabled={busy || !trimmed}
          className="shrink-0 px-4 py-2 rounded-lg text-sm font-semibold bg-(--color-accent)/20 text-(--color-accent) border border-(--color-accent) hover:bg-(--color-accent)/30 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed transition-all"
        >
          {t('upload.link.submit')}
        </button>
      </div>
    </form>
  );
}
